// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// luismrosero1992@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyAKdjMShuzJ0i904xD90MR-JFAUvTKtEGc",
    authDomain: "ecopharmaline.firebaseapp.com",
    projectId: "ecopharmaline",
    storageBucket: "ecopharmaline.firebasestorage.app",
    messagingSenderId: "548963108810",
    appId: "1:548963108810:web:4a5a33375c52c031d7b133",
    measurementId: "G-GHGLLC6YCX"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)